import { ISystemLoaderState } from './../reducers/system-loader.reducer';
import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromSystemLoader from './../reducers/system-loader.reducer';


export const getSystemLoaderState = createFeatureSelector<ISystemLoaderState>(fromSystemLoader.systemLoaderFeatureKey);

export const numActiveProcesses$ = createSelector(
    getSystemLoaderState,
    (state: ISystemLoaderState) => state.numActiveProcesses
);
